import React from 'react';
import styled from 'styled-components';
import {
  Card,
  IntegrationName,
  IntegrationDesc,
  IntegrationHeader,
} from './styles';

interface IntegrationCardProps {
  name: string;
  description: string;
  button: React.ReactNode;
  logo: React.ReactNode;
  live?: boolean;
}

export const ButtonContainer = styled.div`
  display: flex;
`;

export const IntegrationCard = ({
  name,
  logo,
  description,
  button,
}: IntegrationCardProps) => (
  <Card>
    <IntegrationHeader>{logo}</IntegrationHeader>
    <IntegrationName level={2}>{name}</IntegrationName>
    <IntegrationDesc>{description}</IntegrationDesc>
    <ButtonContainer>{button}</ButtonContainer>
  </Card>
);
